export const ResetEmailForm = {
  flow: 'y',
  if: (el, s) => !s.token,
  flow: 'column',
  gap: 'A',
  flex: '1',
  height: '100%',
  '@mobileL': {
    align: 'center unset',
    height: 'unset'
  },
  childExtends: {
    extends: 'InputField',
    width: '100%',
    Title: {},
    Input: {
      width: '100%'
    }
  },
  Email: {
    Title: {
      text: 'Email'
    },
    Input: {
      height: 'B2',
      '@mobileL': {
        height: 'unset'
      },
      autocomplete: 'username',
      value: (el, s) => s.email || '',
      placeholder: 'e.g. hello@symbo.ls',
      onInput: (ev, el, s) => {
        s.update({
          touched: true,
          email: el.node.value
        })
      }
    },
    Label: {
      show: (el, st) => st.touched === true && !st.email,
      color: 'red',
      text: 'Email field is required'
    }
  },
  ModalFooter: {
    ignoreChildExtends: true,
    display: 'flex',
    flow: 'row',
    width: '100%',
    maxWidth: 'unset',
    align: 'center space-between',
    gap: 'Z',
    padding: 'B1 0 0',
    '@mobileL': {
      flow: 'column',
      gap: 'A2',
      childProps: {
        width: '100%'
      }
    },
    CheckButton: {
      theme: 'primary',
      text: 'Reset password',
      type: 'submit',
      Icon: null,
      width: '100%',
      height: 'B2',
      padding: 'Z1 C1 Z1 B1',
      '@mobileL': {
        width: '100%',
        maxWidth: '100%',
        height: 'unset'
      }
    }
  }
}
